import {
  CasinosIcon,
  CategoriesIcon,
  ClientsIcon,
  CollectionsIcon,
  CountriesIcon,
  DemoIcon,
  EnvironmentsIcon,
  GamesIcon,
  IntegratorsIcon,
  JurisdictionIcon,
  ListIcon,
  PhotoGalleryIcon,
  ReportIcon,
  RoundVisualIcon,
  SoftwareIcon,
  TasksIcon,
  TestSuiteIcon,
} from "@/v1/components/atoms/Icons";

export default [
  {
    key: "integrations",
    title: "label.integrations",
    options: [
      {
        key: "integrations.integrator",
        path: "/integrators",
        title: "label.integrators",
        icon: IntegratorsIcon,
      },
      {
        key: "integrations.software",
        path: "/software",
        title: "label.software",
        icon: SoftwareIcon,
      },
      {
        key: "integrations.games",
        path: "/games",
        title: "label.games",
        icon: GamesIcon,
        isActive: (currentPath) => {
          return currentPath.startsWith("/games") && !currentPath.includes("/categories");
        },
      },
      {
        key: "tools.game-gallery",
        path: "/game-gallery",
        title: "label.game-gallery",
        icon: PhotoGalleryIcon,
      },
      {
        key: "integrations.tables",
        path: "/tables",
        title: "label.tables",
        icon: SoftwareIcon,
      },
    ],
  },
  {
    key: "clients",
    title: "label.clients",
    options: [
      {
        key: "clients.operators",
        path: "/operators",
        title: "label.operators",
        icon: ClientsIcon,
      },
      {
        key: "clients.casinos",
        path: "/casinos",
        title: "label.casinos",
        icon: CasinosIcon,
      },
      {
        key: "clients.environments",
        path: "/environments",
        title: "label.environments",
        icon: EnvironmentsIcon,
      },
    ],
  },
  {
    key: "support",
    title: "label.support",
    options: [
      {
        key: "support.round-visual",
        path: "/round-visuals",
        title: "label.round-visual",
        icon: RoundVisualIcon,
      },
      {
        key: "support.trace-id",
        path: "/trace-id-check",
        title: "label.trace-id-check",
        icon: SoftwareIcon,
      },
      {
        key: "label.session-check",
        path: "/session-check",
        title: "label.session-check",
        icon: SoftwareIcon,
      },
      {
        key: "label.round-check",
        path: "/round-check",
        title: "label.round-check",
        icon: SoftwareIcon,
      },
      {
        key: "label.players-check",
        path: "/player-check",
        title: "label.player-check",
        icon: SoftwareIcon,
      },
    ],
  },
  {
    key: "invoicing",
    title: "label.invoicing",
    options: [
      {
        key: "invoicing.currency-report",
        title: "label.currency-report",
        icon: ReportIcon,
      },
      {
        key: "invoicing.bonus-report",
        path: "/bonus-report",
        title: "label.bonus-report",
        icon: ReportIcon,
        permissions: "INVOICING_READ",
      },
      {
        key: "invoicing.invoicing-report",
        path: "/invoicing-report",
        title: "label.invoicing-report",
        icon: ReportIcon,
        permissions: "INVOICING_READ",
      },
      {
        key: "invoicing.transaction-report",
        title: "label.transaction-report",
        path: "/transaction-report",
        icon: ReportIcon,
        permissions: "INVOICING_READ",
      },
      {
        key: "invoicing.smart-transaction-report",
        title: "label.smart-transaction-report",
        path: "/smart-transaction-report",
        icon: ReportIcon,
        permissions: "INVOICING_READ",
      },
    ],
  },
  {
    key: "tools",
    title: "label.tools",
    options: [
      {
        key: "tools.game-lab",
        path: "/game-lab",
        title: "label.game-lab",
        icon: DemoIcon,
        isActive: (path) => path.includes("/game-lab") && !path.includes("/game-lab-v3"),
      },
      {
        key: "tools.casino-collection-executions",
        path: "/casino-collection-executions",
        title: "label.casino-collection-executions",
        icon: TestSuiteIcon,
      },
      {
        key: "tools.sales-matrix",
        path: "/sales-matrix",
        title: "label.sales-matrix",
        icon: ReportIcon,
      },
      {
        key: "tools.client-test-tool",
        path: "/testing-client",
        title: "label.client-test-tool",
        icon: DemoIcon,
      },
      {
        key: "tools.uuid-generator",
        path: "/uuid-generator",
        title: "label.uuid-generator",
        icon: DemoIcon,
      },
      {
        key: "tools.test-newsletter",
        title: "label.test-newsletter",
        icon: DemoIcon,
      },
    ],
  },
  {
    key: "tasks",
    title: "label.tasks",
    options: [
      {
        key: "my-tasks",
        path: "/my-tasks",
        title: "label.my-tasks",
        icon: ListIcon,
      },
      {
        key: "tasks",
        path: "/tasks",
        title: "label.alea-tasks",
        icon: ClientsIcon,
      },
    ],
  },
  {
    key: "administration",
    title: "label.administration",
    options: [
      {
        key: "administration.categories",
        path: "/games/categories",
        title: "label.categories",
        icon: CategoriesIcon,
      },
      {
        key: "administration.global-collections",
        path: "/global-collections",
        title: "label.global-collections",
        icon: CollectionsIcon,
      },
      {
        key: "administration.markets",
        path: "/markets",
        title: "label.markets",
        icon: CountriesIcon,
      },
      {
        key: "administration.jurisdictions",
        path: "/jurisdictions",
        title: "label.jurisdictions",
        icon: JurisdictionIcon,
      },
      {
        key: "administration.countries",
        path: "/countries",
        title: "label.countries",
        icon: CountriesIcon,
      },
      {
        key: "administration.currencies",
        path: "/currencies",
        title: "label.currencies",
        icon: CountriesIcon,
      },
      {
        key: "administration.languages",
        path: "/languages",
        title: "label.languages",
        icon: CountriesIcon,
      },
      {
        key: "businessIntelligence.dashboards",
        path: "/dashboards",
        title: "label.dashboards",
        icon: ReportIcon,
      },
      {
        key: "businessIntelligence.team-members",
        path: "/team-members",
        title: "label.team-members",
        icon: ClientsIcon,
        ownerOnly: true,
        permissions: "ROLE_PERMISSIONS_READ",
      },
      {
        key: "businessIntelligence.roles-and-permissions",
        path: "/roles-and-permissions",
        title: "label.roles-and-permissions",
        icon: TasksIcon,
        ownerOnly: true,
        permissions: "ROLE_PERMISSIONS_READ",
      },
    ],
  },
].filter(Boolean);
